/**
 * Provides an interface for modifying the list of options associated with a `Field`.
 * ## Fields
 * Name | Description
 * --- | ---
 * model | The `Field` containing models associated with this view.
 * @module app/views/layer/DataFieldValuesEditor
 */
import Backbone from "backbone";
import _ from "underscore";
import DataFieldRulesEditor from "app/views/layer/DataFieldRulesEditor";

export default Backbone.View.extend({
  className: "options col-sm-12 data-field-values-editor",
  template: _.template(
    '<div class="form-group col-sm-10"><label for="label" class="control-label">Field Options</label><textarea class="col-sm-11 option-editor"/></div><button type="button" class="btn btn-default col-sm-2 option-sort">Sort&nbsp;<i class="glyphicon glyphicon-sort-by-alphabet"/></button><div class="rules-container clearfix"></div>'
  ),
  _skipEvents: false,
  _editingValue: null,

  events: {
    "tokenfield:createtoken .option-editor": function (evt) {
      this._skipEvents = true;
      if (this._editingValue) {
        this.model.setListValue(this._editingValue, evt.attrs.label);
        this._editingValue = null;
      } else if (evt.attrs.value && evt.attrs.value != evt.attrs.label) {
        //value != label means it's a newly added item
        this.model.setListValue(evt.attrs.value, evt.attrs.label);
      } else {
        var listValue = this.model.setListValue(evt.attrs.label);

        if (listValue) {
          evt.attrs.value = listValue.value;
        }
      }
      this._skipEvents = false;
    },
    "keyup .tokenfield .token-input": function (evt) {
      if (evt.keyCode == 13) {
        //13 = enter
        evt.stopPropagation();
      }
    },
    "tokenfield:removedtoken .option-editor": function (evt) {
      this._skipEvents = true;
      this.model.removeListValue(evt.attrs.value);
      this._skipEvents = false;
    },
    "tokenfield:edittoken .option-editor": function (evt) {
      this._skipEvents = true;
      this._editingValue = evt.attrs.value;
      evt.attrs.value = evt.attrs.label;
      this._skipEvents = false;
    },
    "click .option-sort": "sortValues",
  },

  /**
   * Sorts the option values in the field alphabetically and sets the result into the field "values" property.
   */
  sortValues: function () {
    this.model.set("values", _.sortBy(this.model.get("values"), "text"));
  },

  /**
   * Initializes the view.
   * @param  {object} options The options hash.
   * @param {app/Field} options.model The `Field` containing the models to associate with this view.
   */
  initialize: function (options) {
    this.options = options;
    this.values = this.model.get("values");
    this.model = this.options.model;
    this.fields = this.options.fields;
  },

  render: function () {
    var self = this;
    this.$el.html(this.template(this.options));

    this.dataFieldRulesEditor = new DataFieldRulesEditor({
      model: this.model,
      fields: this.fields,
    });

    var $optionEditor = this.$(".option-editor");

    function parseTokens(fieldValues) {
      return _.map(fieldValues, function (value) {
        return { value: value.value, label: value.text };
      });
    }

    $optionEditor.tokenfield({
      tokens: parseTokens(this.values),
    });

    this.model.on(
      "value-added value-removed change:values",
      function () {
        if (!this._skipEvents) {
          $optionEditor.tokenfield("setTokens", parseTokens(this.values));
        }
      },
      this
    );

    this.model.on(
      "value-added",
      function (valueId, value) {
        self.dataFieldRulesEditor.addValue(value);
      },
      this
    );

    this.model.on(
      "value-removed",
      function (valueId, value) {
        self.dataFieldRulesEditor.removeValue(value);
      },
      this
    );

    var hasRules = false;
    this.values.forEach(function (value) {
      if (value.rules != undefined && value.rules.length > 0) {
        hasRules = true;
      }
    });
    if (hasRules == true) {
      this.addRule();
    }
  },
  addRule: function () {
    this.dataFieldRulesEditor.render();
    this.dataFieldRulesEditor.$el.appendTo(this.$(".rules-container"));
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/layer/DataFieldValuesEditor.js
// module id = 887
// module chunks = 1